import DateTime from "../../node_modules/luxon/src/datetime";

const MatchingLoads = ({ loadNumbers }) => {
  const newArr = loadNumbers.filter((l) => l !== 0);
  if (newArr.length > 0) {
    return <td>{newArr.join(", ")}</td>;
  } else {
    return <td>{""}</td>;
  }
};

// date funcs

function monthNumberOfDays(month, year) {
  return new Date(year, month, 0).getDate();
}

function getFormattedDate(theDate, useLoadNumbers) {
  try {
    var date = new Date(`${theDate}T00:00:00`);
    if (useLoadNumbers) {
      date = new Date(theDate);
    }
    const offset = -date.getTimezoneOffset();
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;
    const offsetSign = offset >= 0 ? "+" : "-";

    const timezone = `${offsetSign}${String(offsetHours).padStart(
      2,
      "0",
    )}:${String(offsetMinutes).padStart(2, "0")}`;
    const formattedDate =
      date.toISOString().split("T")[0] + `T00:00:00${timezone}`;
    return formattedDate;
  } catch {
    return theDate;
  }
}

function getModifiedDate(theDate) {
  try {
    // Parse the input date string into a JavaScript Date object
    const date = new Date(theDate);

    // Use Intl.DateTimeFormat to convert to Central Time
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Chicago", // Central Time Zone
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    // Format the date
    const formattedDate = formatter.format(date);
    return new Date(formattedDate);
  } catch (error) {
    return error;
  }
}

function getLocalModifiedDate(theDate) {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  try {
    const date = new Date(theDate);

    // Use Intl.DateTimeFormat to convert date
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: tz, // Central Time Zone
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    // Format the date
    const formattedDate = formatter.format(date);
    return new Date(formattedDate);
  } catch (error) {
    return error;
  }
}

function getLocalDateString(theDate) {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  try {
    const date = new Date(theDate);

    // Use Intl.DateTimeFormat to convert date
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: tz, // Central Time Zone
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    // Format the date
    const formattedDate = formatter.format(date);
    return formattedDate;
  } catch (error) {
    return error;
  }
}

function getModifiedDateluxon(theDate) {
  try {
    // Parse the input date string into a JavaScript Date object
    const newDate = DateTime.fromFormat(theDate, "MM/dd/yy, hh:mm a", {
      zone: "America/Chicago",
    });

    return newDate.toUTC().toJSDate();
  } catch (error) {
    return error;
  }
}

function getDateForDownload(theDate) {
  try {
    // Parse the input date string into a JavaScript Date object
    const date = new Date(theDate);

    // Use Intl.DateTimeFormat to convert to Central Time
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Chicago", // Central Time Zone
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    // Format the date
    const formattedDate = formatter.format(date);

    return formattedDate;
  } catch (error) {
    return error;
  }
}
function getDateWithoutTimestamp(theDate) {
  try {
    // Parse the input date string into a JavaScript Date object
    const date = new Date(theDate);

    // Use Intl.DateTimeFormat to convert to Central Time
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Chicago", // Central Time Zone
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
    });

    // Format the date
    const formattedDate = formatter.format(date);

    return formattedDate;
  } catch (error) {
    return error;
  }
}

function getTimezoneOffset(timeZone) {
  const str = new Date().toLocaleString("en", {
    timeZone,
    timeZoneName: "longOffset",
  });
  const [, h, m] = str.match(/([+-]\d+):(\d+)$/) || ["", "+00", "00"];
  return h * 60 + (h > 0 ? +m : -m);
}

function getTimezoneOffsetDiff(theDate) {
  const yr = theDate.getFullYear();
  const month = theDate.getMonth() + 1;
  const day = theDate.getDate();
  const hrs = theDate.getHours();
  const min = theDate.getMinutes();
  const sec = theDate.getSeconds();
  const ms = theDate.getMilliseconds();
  var utcDate = new Date(Date.UTC(yr, month, day, hrs, min, sec, ms));
  const offset = utcDate.getTimezoneOffset();
  const centralOffset = getTimezoneOffset("America/Chicago");
  const adjustment = (offset + centralOffset) / 60;
  return -adjustment;
}

function parseDateInCentral(theDate, isEnd) {
  const zone = "America/Chicago";

  const base = DateTime.fromISO(theDate, { zone });
  const dt = isEnd
    ? base.set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
    : base.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

  return dt.toJSDate();
}

function parseDateInUtc(theDate, isEnd) {
  const base = DateTime.fromISO(theDate, { zone: "utc" });
  const dt = isEnd
    ? base.set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
    : base.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

  return dt.toJSDate();
}

const logTime = (start, end, message) => {
  const diff = (end.getTime() - start.getTime()) / 1000;
  console.log(`${message} took ${diff} seconds`);
};

function parseLocalDate(input) {
  const [year, month, day] = input.split("-").map(Number);
  return new Date(year, month - 1, day); // JS months are 0-based
}

const handleFreightLoadLogic = (
  l,
  modDate,
  start,
  end,
  billingPreferenceType,
  selectLoadNumbers,
) => {
  var use = false;
  switch (billingPreferenceType) {
    case 26:
      if (
        (modDate >= start &&
          modDate < end &&
          l.matching_load_numbers.length === 1 &&
          l.locked_reason === "" &&
          !l.ticket_is_missing &&
          l.transfer_type_id !== 12 &&
          !l.is_canceled &&
          l.customer_invoice_id === 0) ||
        (selectLoadNumbers.find(
          (x) => x.label === l.load_no && l.customer_invoice_id === 0,
        ) &&
          l.matching_load_numbers.length === 1 &&
          l.locked_reason === "" &&
          !l.ticket_is_missing &&
          l.transfer_type_id !== 12 &&
          !l.is_canceled)
      ) {
        use = true;
      }
      break;
    case 27:
      if (
        (modDate >= start &&
          modDate < end &&
          (l.propconnect_approval_status === "Confirmed" ||
            l.propconnect_approval_status === "Approved" ||
            l.propconnect_approval_status === "Paid") &&
          l.transfer_type_id !== 12 &&
          !l.is_canceled &&
          l.customer_invoice_id === 0) ||
        (selectLoadNumbers.find(
          (x) => x.label === l.load_no && l.customer_invoice_id === 0,
        ) &&
          (l.propconnect_approval_status === "Confirmed" ||
            l.propconnect_approval_status === "Approved" ||
            l.propconnect_approval_status === "Paid") &&
          l.transfer_type_id !== 12 &&
          !l.is_canceled)
      ) {
        use = true;
      }
      break;
    case 28:
      if (
        (modDate >= start &&
          modDate < end &&
          (l.propconnect_approval_status === "Approved" ||
            l.propconnect_approval_status === "Paid") &&
          l.transfer_type_id !== 12 &&
          !l.is_canceled &&
          l.customer_invoice_id === 0) ||
        (selectLoadNumbers.find(
          (x) => x.label === l.load_no && l.customer_invoice_id === 0,
        ) &&
          (l.propconnect_approval_status === "Approved" ||
            l.propconnect_approval_status === "Paid") &&
          l.transfer_type_id !== 12 &&
          !l.is_canceled)
      ) {
        use = true;
      }
      break;
    default:
      use = false;
      break;
  }
  return use;
};

const handleAssetLoadLogic = (
  l,
  modDate,
  start,
  end,
  billingPreferenceType,
  selectLoadNumbers,
) => {
  var use = false;
  switch (billingPreferenceType) {
    case 26:
      if (
        (modDate >= start &&
          modDate < end &&
          l.locked_reason === "" &&
          l.customer_invoice_id === 0) ||
        (selectLoadNumbers.find(
          (x) => x.label === l.load_no && l.customer_invoice_id === 0,
        ) &&
          l.locked_reason === "")
      ) {
        use = true;
      }
      break;
    case 27:
      if (
        (modDate >= start &&
          modDate < end &&
          (l.propconnect_approval_status === "Confirmed" ||
            l.propconnect_approval_status === "Approved" ||
            l.propconnect_approval_status === "Paid") &&
          l.customer_invoice_id === 0) ||
        (selectLoadNumbers.find(
          (x) => x.label === l.load_no && l.customer_invoice_id === 0,
        ) &&
          (l.propconnect_approval_status === "Confirmed" ||
            l.propconnect_approval_status === "Approved" ||
            l.propconnect_approval_status === "Paid"))
      ) {
        use = true;
      }
      break;
    case 28:
      if (
        (modDate >= start &&
          modDate < end &&
          (l.propconnect_approval_status === "Approved" ||
            l.propconnect_approval_status === "Paid") &&
          l.customer_invoice_id === 0) ||
        (selectLoadNumbers.find(
          (x) => x.label === l.load_no && l.customer_invoice_id === 0,
        ) &&
          (l.propconnect_approval_status === "Approved" ||
            l.propconnect_approval_status === "Paid"))
      ) {
        use = true;
      }
      break;
    default:
      use = false;
      break;
  }
  return use;
};

const wrapWithQoutes = (val) => {
  const str = String(val ?? "");
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export {
  monthNumberOfDays,
  MatchingLoads,
  getFormattedDate,
  getModifiedDate,
  getLocalModifiedDate,
  getLocalDateString,
  getDateForDownload,
  getDateWithoutTimestamp,
  getModifiedDateluxon,
  logTime,
  parseLocalDate,
  getTimezoneOffset,
  getTimezoneOffsetDiff,
  parseDateInCentral,
  parseDateInUtc,
  handleFreightLoadLogic,
  handleAssetLoadLogic,
  wrapWithQoutes,
};
